import { forwardRef, ReactNode } from 'react';
import { createButtonTheme } from 'theme/button';
import { ThemeProvider } from 'components/base/system/theme';
import MuiButton, { ButtonProps } from '@mui/material/Button';
import { Stack } from 'components/base/layout/Stack';
import { CircularProgress } from 'components/atoms/CircularProgress';
import { CircularProgressProps } from '@mui/material/CircularProgress';
export interface MuiButtonProps extends Omit<ButtonProps, 'variant'> {
  children: ReactNode;
  isLoading?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  target?: '_blank' | '_self' | '_parent' | '_top';
  loaderProps?: CircularProgressProps;
  variant?:
    | 'contained'
    | 'outlined'
    | 'text'
    | 'outlinedPrimary'
    | 'outlinedSecondary'
    | 'containedPrimary'
    | 'containedSecondary'
    | 'textSecondary'
    | 'textPrimary'
    | 'containedError'
    | 'outlinedError';
}

export const Button = forwardRef<HTMLButtonElement, MuiButtonProps>(
  (
    {
      children,
      isLoading = false,
      startIcon,
      endIcon,
      loaderProps,
      variant = 'contained',
      ...rest
    },
    ref,
  ) => (
    <ThemeProvider theme={createButtonTheme}>
      <MuiButton
        ref={ref}
        disabled={isLoading}
        target="_blank"
        variant={variant as ButtonProps['variant']}
        startIcon={
          <Stack alignItems="center" gap={0.2}>
            {isLoading ? (
              <CircularProgress
                size={12}
                color="inherit"
                {...loaderProps}
                sx={{
                  fontSize: '12px',
                }}
              />
            ) : (
              startIcon
            )}
          </Stack>
        }
        endIcon={
          endIcon ? (
            <Stack alignItems="center" gap={0.2}>
              {endIcon}
            </Stack>
          ) : undefined
        }
        {...rest}
      >
        {children}
      </MuiButton>
    </ThemeProvider>
  ),
);
